export default __webpack_public_path__ + "static/media/shirt.8552a1ef.webp";